import * as api from './api';
import { supabase } from '../supabaseClient';
import { getOrgId } from './orgStore';
import { fetchTaxes } from './taxService';

// Read from the stock view, but write to the base table.
const READ_TABLE = 'item_with_stock';
const WRITE_TABLE = 'item';
const PK = 'item_id';

/**
 * Fetch items with joined category/supplier names,
 * plus the dropdown dependency lists (categories, suppliers, taxes).
 */
export const fetchItems = async (searchTerm = '') => {
  // Fetch dependency lists in parallel
  const [categories, suppliers, taxes] = await Promise.all([
    api.fetchRecords('category'),
    api.fetchRecords('supplier'),
    fetchTaxes(),
  ]);

  const orgId = getOrgId();
  if (!orgId) throw new Error('No org selected (org_id is null).');

  let query = supabase
    .from(READ_TABLE)
    .select('*, category:category_id(category_name), supplier:supplier_id(supplier_name)')
    .eq('org_id', orgId);

  if (searchTerm) {
    query = query.ilike('sales_description', `%${searchTerm}%`);
  }

  const { data, error } = await query;
  if (error) throw error;

  return { items: data || [], categories, suppliers, taxes };
};

/** Item IDs are user-provided. */
export const createItem = (data) => {
  if (!data[PK]) throw new Error('Please provide a valid Item ID.');
  return api.createRecord(WRITE_TABLE, data);
};

export const updateItem = (id, data) =>
  api.updateRecord(WRITE_TABLE, PK, id, data);

export const deleteItem = (id) =>
  api.deleteRecord(WRITE_TABLE, PK, id);
